import PreOrderItem from '../../views/item/pre_order/pre-order-item.vue';
import PreOrderMethod from '../../views/item/pre_order/pre-order-method.vue';
import PreOrderList from '../../views/item/pre_order/pre-order-list.vue';
import PreOrderedList from '../../views/item/pre_order/pre-ordered-list.vue';
import GLoading from '../../components/Loading.vue';
import UnSupportMessage from '../../components/UnSupportMessage.vue';

window.Vue.component('pre-order-item', PreOrderItem);
window.Vue.component('pre-order-method', PreOrderMethod);
window.Vue.component('pre-order-list', PreOrderList);
window.Vue.component('pre-ordered-list', PreOrderedList);
window.Vue.component('g-loading', GLoading);
window.Vue.component('un-support-message', UnSupportMessage);